// Ticket 27: Lounge Gift Toast Notification Component
import React, { useEffect } from 'react';

const LoungeGiftToast = ({ event, onDone }) => {
  useEffect(() => {
    if (!event) return;
    
    const timeout = setTimeout(() => {
      if (onDone) onDone();
    }, 3000);
    
    return () => clearTimeout(timeout);
  }, [event, onDone]);

  if (!event) return null;

  const { giftEmoji, giftName, fromUserName, toUserName } = event;

  return (
    <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 w-[90%] max-w-md -translate-x-1/2">
      <div className="pointer-events-auto flex items-center gap-3 rounded-2xl bg-slate-900/95 px-4 py-3 text-white shadow-2xl border border-pink-500/40 animate-slide-up">
        {/* Gift Icon */}
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-rose-gold text-2xl flex-shrink-0">
          {giftEmoji || '🎁'}
        </div>
        
        {/* Message */}
        <div className="flex flex-col flex-1 min-w-0">
          <span className="font-semibold text-sm truncate">
            <span className="text-pink-300">{fromUserName || 'Someone'}</span>
            {' sent '}
            <span className="text-purple-300">{toUserName || 'someone'}</span>
          </span>
          <span className="text-xs text-slate-300 truncate">
            {giftName || 'a gift'} in the lounge
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoungeGiftToast;
